import React from 'react';
import clsx from 'clsx';
import { motion, useReducedMotion } from 'framer-motion';
import { Pencil } from 'lucide-react';

function EditHotspot({
  size = 40,
  iconSize = 18,
  ringDuration = 2.8,
  className,
  style,
  label = 'Edit',
}) {
  const prefersReducedMotion = useReducedMotion();

  return (
    <div
      className={clsx('relative inline-flex items-center justify-center', className)}
      style={{ width: size, height: size, ...style }}
      aria-label={label}
      role="img"
    >
      <motion.div
        aria-hidden="true"
        className="absolute inset-0 rounded-full"
        style={{ backgroundColor: 'var(--primary-hover, #1E40AF)' }}
        animate={prefersReducedMotion ? undefined : { scale: [1, 2.2], opacity: [0, 0.45, 0] }}
        transition={
          prefersReducedMotion
            ? undefined
            : {
                duration: ringDuration,
                repeat: Infinity,
                ease: 'linear',
                times: [0, 0.22, 1],
              }
        }
      />

      <div
        className="relative flex items-center justify-center rounded-full shadow-lg"
        style={{
          width: size,
          height: size,
          backgroundColor: 'transparent',
          color: 'var(--primary, #1D4ED8)',
        }}
      >
        <Pencil size={iconSize} aria-hidden="true" />
      </div>
    </div>
  );
}

export default EditHotspot;